<div class="content-card filters">
  <div class="top">
    <div class="top__left"></div>
    <div class="top__right">
      <div class="filter-button-container">
        <button (click)="resetFilters()" class="top__button top__button-clear">
          <mat-icon>close</mat-icon>
          {{ 'Reset' | translate }}
        </button>
        <button
          (click)="toggleFiltersPanel()"
          class="top__button top__button-filter"
          [matBadge]="filters.length"
          matBadgeSize="small"
          [matBadgeHidden]="!filters.length"
          >
          <mat-icon>filter_alt</mat-icon>
          {{ 'Filter' | translate }}
        </button>
      </div>
    </div>
  </div>
  @if (areFiltersExpanded) {
    <app-list-filter></app-list-filter>
  }
</div>
<div class="content-card table-container">
  <!-- Orders Table -->
  <div class="table-wrapper custom-table">
    <mat-table #table matSort matSortDisableClear [dataSource]="dataSource">
      <!-- Submission Date Column - fixed left -->
      <ng-container matColumnDef="submissionDate" sticky>
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort column-fixed-width">
          {{ 'Order.List.SubmissionDate' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="column-fixed-width">{{ element.SubmissionDate | date : 'yyyy-MM-dd' }}</mat-cell>
      </ng-container>

      <!-- Submitter Column -->
      <ng-container matColumnDef="submitterLastName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.List.Submitter' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.SubmitterFullName }}</mat-cell>
      </ng-container>

      <!-- Employer Column -->
      <ng-container matColumnDef="employerName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.List.Employer' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.EmployerName }}</mat-cell>
      </ng-container>

      <!-- Employer Object Column -->
      <ng-container matColumnDef="employerObjectName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.List.EmployerObject' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.EmployerObjectName }}</mat-cell>
      </ng-container>

      <!-- Order Specification Column -->
      <ng-container matColumnDef="positionExpectationName">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort">
          {{ 'Order.List.PositionExpectation' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element">{{ element.PositionExpectationName }}</mat-cell>
      </ng-container>

      <!-- Start Date Column -->
      <ng-container matColumnDef="startDate">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort column-fixed-width">
          {{ 'Order.List.FromDate' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="column-fixed-width">{{ element.StartDate | date : 'yyyy-MM-dd' }}</mat-cell>
      </ng-container>

      <!-- Number of Employees Column -->
      <ng-container matColumnDef="employeesNumber">
        <mat-header-cell *matHeaderCellDef mat-sort-header class="hidden-sort column-fixed-width">
          {{ 'Order.List.EmployeesNumber' | translate }}
          <app-table-header-sort></app-table-header-sort>
        </mat-header-cell>
        <mat-cell *matCellDef="let element" class="column-fixed-width">{{ element.EmployeesNumber }}</mat-cell>
      </ng-container>

      <!-- Actions Column - fixed right -->
      <ng-container matColumnDef="actions" stickyEnd>
        <mat-header-cell *matHeaderCellDef class="column-fixed-width"> {{ 'Actions' | translate }} </mat-header-cell>
        <mat-cell *matCellDef="let element" class="column-fixed-width">
          <ng-container></ng-container>
          @if (screenService.isAboveMd$ | async) {
            @if (hasAnyAction(element)) {
              <button mat-button class="button-text" [matMenuTriggerFor]="menuRow">
                <mat-icon class="material-icons-outlined">more_vert</mat-icon>
              </button>
            }
          } @else {
            @if (hasAnyAction(element)) {
              <button mat-icon-button [matMenuTriggerFor]="menuRow">
                <mat-icon class="material-icons-outlined">more_vert</mat-icon>
              </button>
            }
          }


          <mat-menu #menuRow="matMenu" panelClass="actions-menu">
            @if (editButtonVisible(element)) {
              <button mat-button (click)="editOrderItem(element)">
                <mat-icon>edit</mat-icon>
                <span class="button-text">{{ 'Order.List.EditOrderItem' | translate }}</span>
              </button>
            }
            @if (archiveButtonVisible(element.OrderItemStatusId)) {
              <button mat-button (click)="archiveOrderItem(element.Id)">
                <mat-icon>archive</mat-icon>
                <span class="button-text">{{ 'Order.List.ArchiveOrderItem' | translate }}</span>
              </button>
            }
            @if (restoreButtonVisible(element.OrderItemStatusId)) {
              <button mat-button (click)="restoreOrderItem(element.Id)">
                <mat-icon>unarchive</mat-icon>
                <span class="button-text">{{ 'Order.List.RestoreOrderItem' | translate }}</span>
              </button>
            }
          </mat-menu>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>
</div>

<mat-paginator [length]="dataSource.count$ | async" [pageSize]="10" [pageSizeOptions]="[10, 15, 20]"></mat-paginator>
